import React from 'react';
import { Banner } from 'prospect-path-base';

const CheckEmailBanner = () => (
    <div style={{ marginBottom: '24px' }}>
        <Banner
            type='success'
            title='Email resent successfully'
            children='Make sure to check your junk folder'
            closeable={false}
        >
        </Banner>
    </div>
)

export default CheckEmailBanner;
